export function getWorkPoolThreadDocumentType(thread) {
  const emails = thread?.emails || [];
  const latest = emails.length ? emails[emails.length - 1] : null;
  return latest?.document_type || "UNKNOWN";
}

export function shouldGroupWorkPoolByDocumentType(appliedDocumentTypes) {
  return (appliedDocumentTypes || []).length > 1;
}

export function mergeSelectedTypeCounts(selectedTypes, apiCounts) {
  const totals = new Map(
    (apiCounts || []).map((row) => [
      row.document_type,
      Number(row.total) || 0,
    ]),
  );

  return (selectedTypes || []).map((type) => ({
    document_type: type,
    total: totals.get(type) || 0,
  }));
}

export function groupWorkPoolThreadsByDocumentType(threads) {
  const groups = new Map();

  for (const thread of threads || []) {
    const type = getWorkPoolThreadDocumentType(thread);
    if (!groups.has(type)) {
      groups.set(type, []);
    }
    groups.get(type).push(thread);
  }

  return Array.from(groups.entries()).sort((left, right) =>
    left[0].localeCompare(right[0]),
  );
}
